<template>
  <div>
    <Table
      :items="items"
      :summarizeNumberCount="summarizeNumberCount"
      :summarizeValue="summarizeValue"
      :pagination="pagination"
      :status="currentStatus"
      :activeTab="activeTab"
      summarize
      @reloadData="reloadData"
      @goToPage="updatePage"
      @deleteCredit="openDeleteCreditDialog"
    />

    <DeleteCreditDialog
      :visible="deleteCreditDialog"
      :data="selectedItem"
      @close="closeDeleteCreditDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isArray, isObject } from 'utils/functions'
import Table from 'components/financialAdjustments/TableCredit'
import DeleteCreditDialog from './dialogs/DeleteCreditDialog'

export default {
  name: 'TabCredits',
  props: {
    activeTab: {
      type: Number
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Table,
    DeleteCreditDialog
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.FinancialAdjustmentsPage',
      pagination: {},
      filters: {
        search: null
      },
      currentStatus: null,
      items: [],
      summarizeNumberCount: 0,
      summarizeValue: 0,
      dialogType: null,
      selectedItem: null,
      deleteCreditDialog: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    isValidObject (val) {
      return isObject(val)
    },

    renderData (data) {
      if (this.isValidObject(data)) {
        this.currentStatus = data.status ? data.status : null
        this.items = this.isValidArray(data.tableBody) ? data.tableBody : []
        this.pagination = data.pagination ? { ...data.pagination } : {}
        this.summarizeNumberCount = data.summarizeNumberCount || 0
        this.summarizeValue = data.summarizeValue || 0
      }
    },

    updateFilters (filters) {
      this.filters = { ...filters }
      this.$emit('updateFilters', this.filters)
      this.reloadData()
    },

    resetPagination () {
      this.$emit('resetPagination')
    },

    updatePage (page) {
      scrollTo(0, 0)

      this.pagination = {
        ...this.pagination,
        currentPage: page
      }

      this.$emit('updatePagination', this.pagination)
      this.loadData()
    },

    loadData () {
      this.$emit('loadData')
    },

    reloadData () {
      this.resetPagination()
      this.loadData()
    },

    openDeleteCreditDialog (val) {
      this.selectedItem = val
      this.deleteCreditDialog = true
    },

    closeDeleteCreditDialog (reload) {
      this.selectedItem = null
      this.deleteCreditDialog = false
      reload && this.reloadData()
    }
  },

  watch: {
    data: {
      deep: true,
      handler (val) {
        this.renderData(val)
      }
    }
  }
}
</script>
